import Loggers from '../loggers';

let _loggersWithLevels = [];

const LEVEL_INDEX = ['debug', 'log', 'info', 'warn', 'error'];
const loggerKeyToLogger = {
    eventsLogger: Loggers.EventsLogger,
    consoleLogger: Loggers.ConsoleLogger,
};

function addLoggersFromConfig(config) {
    const {
        loggers,
    } = config;

    Object.keys(loggers).forEach((loggerKey) => {
        const logger = loggerKeyToLogger[loggerKey];
        const loggerConfig = loggers[loggerKey];

        _loggersWithLevels.push({
            logger,
            level: loggerConfig.level,
        });

        if (logger.configure) {
            logger.configure(loggerConfig);
        }

        if (logger.start) {
            logger.start();
        }
    });
}

function getAllThatSupportLevel(requestedLevel) {
    return _loggersWithLevels.filter(({ level }) => {
        const requestedLevelIndex = LEVEL_INDEX.indexOf(requestedLevel);
        const loggerLevelIndex = LEVEL_INDEX.indexOf(level);

        return requestedLevelIndex >= loggerLevelIndex;
    }).map(({ logger }) => logger);
}

function getAll() {
    return _loggersWithLevels.map(({ logger }) => logger);
}

function getEventLogger() {
    return loggerKeyToLogger.eventsLogger;
}

function clear() { // only for testing
    _loggersWithLevels = [];
}

export {
    addLoggersFromConfig,
    clear,
    getAll,
    getAllThatSupportLevel,
    getEventLogger,
};

export default {
    addLoggersFromConfig,
    clear,
    getAll,
    getAllThatSupportLevel,
    getEventLogger,
};
